import { Reducer } from 'redux';
import { ActionType, createStandardAction, getType } from 'typesafe-actions';
import { Actions, RootState } from './rootReducer';

export const appBarActions = {
  open: createStandardAction('@appBar/open')(),
  close: createStandardAction('@appBar/close')(),
};

export type AppBarActions = ActionType<typeof appBarActions>;

export type AppBarState = {
  readonly open: boolean;
};

export const appBarInitialState: AppBarState = {
  open: false,
};

export const appBar: Reducer<AppBarState, Actions> = (state = appBarInitialState, action) => {
  switch (action.type) {
    case getType(appBarActions.open): {
      return { open: true };
    }
    case getType(appBarActions.close): {
      return { open: false };
    }
    default:
      return state;
  }
};

export const appBarSelector = {
  open: (state: RootState) => state.appBar.open,
};
